/* eslint-disable no-shadow */
export enum QuestionTypeEnum {
  OPEN_TEXT = 'open_text',
  RATING = 'rating',
  NPS = 'nps',
  SINGLE_CHOICE = 'single_choice',
  MULTIPLE_CHOICE = 'multiple_choice',
}

export enum SurveyStatusEnum {
  ACTIVE = 'active',
  DRAFT = 'draft',
  SCHEDULED = 'scheduled',
  CLOSED = 'closed',
}

export enum GroupTypeEnum {
  DEPARTMENT = 'departments',
  BUSINESS_UNIT = 'business_units',
  LOCATION = 'locations',
}
